import request from "@/utils/request";

export function newsList(data) {
  return request({
    url: "/business/businessAfficheInfo/list",
    method: "post",
    data
  });
}
export function newsInfo(id) {
  return request({
    url: "/business/businessAfficheInfo/info?id=" + id,
    method: "post"
  });
}



// WEBPACK FOOTER //
// ./src/api/news.js